var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMerchantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.003,
    height: 16.003,
    viewBox: "0 0 16.003 16.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3",
    "data-name": 3,
    d: "M61,596.091A2.094,2.094,0,0,0,58.908,594H47.092A2.094,2.094,0,0,0,45,596.091v11.816A2.094,2.094,0,0,0,47.092,610H58.908A2.094,2.094,0,0,0,61,607.907Zm-8.045,1.619a2.043,2.043,0,1,1-2.042,2.042A2.042,2.042,0,0,1,52.957,597.71Zm3.308,9.452H49.792a1.123,1.123,0,0,1-1.117-1.124,4.21,4.21,0,0,1,2.627-3.9,2.9,2.9,0,0,0,3.361-.037,4.211,4.211,0,0,1,2.72,3.938A1.123,1.123,0,0,1,56.265,607.161Z",
    transform: "translate(-44.998 -593.997)",
    fill: "#aaa"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantIcon);
export default __webpack_public_path__ + "static/media/merchant-icon.4e8b6911.svg";
export { ForwardRef as ReactComponent };